import React, { useEffect, useState } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import HEADER from "../Components/header";
import TitleSection from "../Components/GatewayAdmin/Main/titleSection";
import GatewayAdminModalAction from '../Components/GatewayAdmin/Modal/GatewayAdminModaAction';
import baseUrlApi from '../lib/baseUrlApi';
import { useCookies } from 'react-cookie';
import {ApiRequest} from "../Consts/ApiRequest";
import {useNavigate} from "react-router-dom";

type GatewayAdminInputs = {
    gatewayAdminId1: string;
    gatewayAdminId2: string;
    controlID: string;
    gatewayRecno: number;
};

const GatewayAdmin = () => {
    const navigate = useNavigate();
    const [gatewayAdminData, setGatewayAdminData] = useState<GatewayAdminInputs[]>([]);
    // const [gatewayID, setGatewayID] = useState<string>("");
    const [controlID, setControlID] = useState<string>("");
    const [gatewayRecno, setGatewayRecno] = useState<number>(0);
    // モーダルに渡す値の管理
    const [selectedGateway, setSelectedGateway] = useState<GatewayAdminInputs | null>(null);
    const [state, setState] = useState("")
    const { register, handleSubmit, formState: { errors } } = useForm<GatewayAdminInputs>();
    const [cookies, setCookie, removeCookie] = useCookies(['authority', 'access_token', "siteId", "siteRecno"]);
    const authority = cookies.authority;

    function errorCallback(error:any){
        if (error.response && error.response.status === 401) {
            console.error("Error token error:", error);
            removeCookie('access_token', {path: '/'});
            removeCookie('authority', {path: '/'});
            removeCookie('siteId', {path: '/'});
            removeCookie('siteRecno', {path: '/'});
            navigate("logout");
        }
        console.error("Error fetching dataSite:", error);
    }

    const getGateway = () =>{
        setGatewayAdminData([]);
        let params ={
            "prcKind": 1,
            "deviceInfo": {
                "gatewayRecno": gatewayRecno,
                "controlID": controlID,
                "gatewayID": "",
                "serialNO": "",
            }
        };
        const token = cookies.access_token || "";
        ApiRequest.getGateway(params, token, (response:any) => {
            if (response.data && Array.isArray(response.data.devices)) {
                setGatewayAdminData(response.data.devices);
            }
        }, (error:any) => {
            errorCallback(error);
        });
    }

    const changeState = (isState: string) => {
        setState(isState);
        let params = {prcKind: 0};
        getGateway();
    }

    useEffect(() => {
        if(cookies.authority == 2 || cookies.authority == 3 || cookies.authority == 4) {
            removeCookie('access_token', {path: '/'});
            removeCookie('authority', {path: '/'});
            removeCookie('siteId', {path: '/'});
            removeCookie('siteRecno', {path: '/'});
            navigate("logout");
        }
        let params = {prcKind: 0};
        setGatewayAdminData([]);
        const token = cookies.access_token || "";
        ApiRequest.getGateway(params,  token, (response:any) => {
            if (response.data && Array.isArray(response.data.devices)) {
                setGatewayAdminData(response.data.devices);
            }
        }, (error:any) => {
            errorCallback(error);
        });
    }, [state]);

    const onSubmit: SubmitHandler<GatewayAdminInputs> = async (data) => {
        getGateway();
    };
    return (
        <>
            <div className="wrapper">
                <HEADER />
                <main className="main">
                    <TitleSection
                    controlID={""}
                    prcKind={0}
                    gatewayRecno={0}
                    changeState={changeState}
                    getGatewaySensor={changeState}
                    />
                    <section className="page-body scroll-block">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="search-box">
                                <div className="search-box-elm">
                                    <div className="search-box-elm-name">
                                        Gateway管理番号 {state}
                                    </div>
                                    <div className="search-box-elm-input">
                                        <input
                                            type="text"
                                            value={controlID}
                                            placeholder="controlID"
                                            {...register("controlID",)}
                                            className="col-320"
                                            onChange={e => setControlID(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="search-box-btn">
                                    <button className="btn btn-white-line"><i className="icon-search-w"></i>検索</button>
                                </div>
                            </div>
                        </form>

                        <div className="table-box">
                            <table className="st-table">
                                <thead>
                                    <tr>
                                        <th className="">Gateway管理番号</th>
                                        <th className="col-100"> 編集</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {gatewayAdminData.map((item, index) => (
                                        <tr key={index}>
                                            <td className="nowrap">{item.controlID}</td>
                                            <td className="">
                                                <GatewayAdminModalAction
                                                    controlID={item.controlID}
                                                    prcKind={1}
                                                    gatewayRecno={item.gatewayRecno}
                                                    setState={changeState}
                                                    getGatewaySensor={changeState}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                    </section>
                </main>
            </div >
        </>
    );
};

export default GatewayAdmin;
